import React from 'react';
import { Grid3x3, MapPin, Target } from "lucide-react";
import { OrganicBlob2, OrganicBlob3 } from "../../../shared/decorations/OrganicBlob";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../core/contexts/AuthContext';

function GameCard({ icon, title, status, description, isComingSoon, onClick }) {
  return (
    <div
      onClick={onClick}
      className={`p-8 rounded-2xl transition-all duration-300 ${
        isComingSoon
          ? 'border-2 border-dashed cursor-not-allowed'
          : 'border hover:shadow-[0_0_20px_rgba(139,157,131,0.3)] cursor-pointer'
      }`}
      style={{
        backgroundColor: isComingSoon ? 'transparent' : '#1A1A1A',
        borderColor: '#3A4238',
        borderRadius: '16px',
        aspectRatio: '4/3',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className={isComingSoon ? 'opacity-30' : ''}>
        {icon}
      </div>

      <h3
        className="mt-6 mb-3"
        style={{
          color: isComingSoon ? '#E8DCC4' : '#FAFAF8',
          fontSize: isComingSoon ? '20px' : '24px',
          fontWeight: '600'
        }}
      >
        {title}
      </h3>

      {status && (
        <span
          className="px-4 py-1 mb-3 rounded-full"
          style={{
            backgroundColor: '#8B9D83',
            color: '#FAFAF8',
            fontSize: '12px',
            fontWeight: '500',
          }}
        >
          {status}
        </span>
      )}

      {description && (
        <p style={{ color: '#E8DCC4', fontSize: '14px', textAlign: 'center' }}>
          {description}
        </p>
      )}
    </div>
  );
}

export function TodaysGames() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const handleWordleClick = () => {
    if (currentUser && currentUser.emailVerified) {
      navigate('/game');
    }
    // If not authenticated, do nothing (they need to use hero CTA)
  };

  const handleCampusGuesserClick = () => {
    if (currentUser && currentUser.emailVerified) {
      navigate('/campus-guesser');
    }
    // If not authenticated, do nothing (they need to use hero CTA)
  };

  return (
    <section className="py-20 px-6 relative overflow-hidden" style={{ paddingTop: '120px', paddingBottom: '80px', backgroundColor: '#1A1A1A' }}>
      {/* Background decorations */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <OrganicBlob2 className="absolute w-80 h-80 -left-20 top-10 animate-pulse" style={{ animationDelay: '0.8s' }} />
        <OrganicBlob3 className="absolute w-72 h-72 -right-16 bottom-0 animate-pulse" style={{ animationDelay: '1.2s' }} />
      </div>

      <div className="max-w-[1200px] mx-auto relative z-10">
        {/* Section title */}
        <h2
          className="text-center mb-10"
          style={{
            color: '#FAFAF8',
            fontSize: '32px',
            fontWeight: '600'
          }}
        >
          Play Now
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <GameCard
            icon={<Grid3x3 size={64} strokeWidth={1.5} style={{ color: '#8B9D83' }} />}
            title="Howard Wordle"
            status="Today's Challenge"
            description="5-letter words. Howard edition."
            onClick={handleWordleClick}
          />
          <GameCard
            icon={<MapPin size={64} strokeWidth={1.5} style={{ color: '#8B9D83' }} />}
            title="Campus Guesser"
            status="Today's Challenge"
            description="Guess the campus location."
            onClick={handleCampusGuesserClick}
          />
          <GameCard
            icon={<Target size={64} strokeWidth={1.5} style={{ color: '#8B9D83' }} />}
            title="Coming Soon"
            isComingSoon
          />
        </div>
      </div>
    </section>
  );
}
